import { apis, apiHolder } from 'api';
import { emojiSourceMap, emojiList } from '../common/emojiList';
const nimApi = apiHolder.api.requireLogicalApi(apis.imApiImpl);
const htmlApi = apiHolder.api.requireLogicalApi(apis.htmlApi);
const systemApi = apiHolder.api.getSystemApi();
export const LINGXI_IM_TEAM_DEFAULT_NAME = 'LINGXI_IM_TEAM_DEFAULT_NAME_c1c50e13';
export const EMOJI_TAG_REGEXP = new RegExp('\\[[^\\[\\]]+\\]', 'g');
import { ERROR_FALLBACK as _ERROR_FALLBACK } from './const';
export const TEAM_AUTH_EXPLAIN = {
    teamAvatar: ['owner', 'manager', 'normal'],
    teamNameIntro: ['owner', 'manager', 'normal'],
    teamAnnouncement: ['owner', 'manager', 'normal'],
};
export const ERROR_FALLBACK = _ERROR_FALLBACK;
export const base64ConvertFile = (base64Data) => {
    if (typeof base64Data !== 'string') {
        return;
    }
    const arr = base64Data.split(',');
    const type = arr[0].match(/:(.*?);/)[1];
    const fileExt = type.split('/')[1];
    const bstr = atob(arr[1].replace(/\s/g, ''));
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n >= 0) {
        u8arr[n] = bstr.charCodeAt(n);
        n -= 1;
    }
    return new File([u8arr], 'image.' + fileExt, { type });
};
export const filterContactListByYunxin = (list) => filterContactListByType(list, 'yunxin');
export const filterContactListByType = (list, type) => {
    if (!(list === null || list === void 0 ? void 0 : list.length)) {
        return [];
    }
    const res = [];
    list.forEach(item => {
        const { contact, contactInfo } = item;
        const info = contactInfo.filter(info => info.contactItemType === type);
        if (info.length) {
            res.push({
                contact,
                contactInfo: info,
            });
        }
    });
    return res;
};
export const getTeamName = (teamDetail) => nimApi.getTeamName(teamDetail);
export const parseValue = (str) => {
    try {
        const obj = JSON.parse(str);
        return obj.text || '';
    }
    catch (_) {
        return str;
    }
};
export const renderMsgContent = (unSafeMsg) => {
    const safeMsg = htmlApi.encodeHtml(unSafeMsg);
    return safeMsg.replace(EMOJI_TAG_REGEXP, item => {
        const emojiName = emojiList.get(item);
        const emojiUrl = emojiSourceMap[emojiName];
        if (emojiUrl) {
            return `<img src=${emojiUrl} width=20 height=20 alt=${item} />`;
        }
        return item;
    });
};
export const judgeMsgType = (msg, typeStr, type) => {
    let typeCorrect = false;
    try {
        typeCorrect = JSON.parse(msg.content || '{}')[typeStr] === type;
    }
    catch (e) { }
    return typeCorrect;
};
export const getDistanceFromTop = () => {
    const inElectron = systemApi.isElectron();
    const isEdmWeb = systemApi.inEdm() && !inElectron;
    const isInWinElectron = inElectron && /windows/i.test(navigator.userAgent);
    if (isInWinElectron) {
        return 88;
    }
    if (isEdmWeb) {
        return 110;
    }
    if (!inElectron) {
        return 102;
    }
    return 56;
};
export const getImTeamDistanceFromTop = (editWindowHeight) => {
    const curWinHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    if (!curWinHeight || !editWindowHeight) {
        return 'none';
    }
    const distanceFromTop = getDistanceFromTop();
    const actualDistance = distanceFromTop + 8 + 48;
    return Math.min(curWinHeight - editWindowHeight - actualDistance, 412);
};
